import { resolveProblemDetailsMessage } from './problemMessage';
import type { ProblemDetails } from './types';

export class ApiError extends Error {
  status: number | undefined;
  details: ProblemDetails | undefined;

  constructor(message: string, status?: number, details?: ProblemDetails) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.details = details;
  }

  static fromAxiosError(err: unknown): ApiError {
    if (err && typeof err === 'object' && 'response' in err) {
      const axiosErr = err as {
        response?: { status?: number; data?: ProblemDetails };
      };
      const status = axiosErr.response?.status;
      const data = axiosErr.response?.data;

      if (data && typeof data === 'object') {
        const message = resolveProblemDetailsMessage(data, 'An unexpected error occurred');
        return new ApiError(message, status, data);
      }

      if (status === 400) return new ApiError('The request was invalid. Check your input and try again.', status);
      if (status === 401) return new ApiError('Unauthorized. Please log in again.', status);
      if (status === 403) return new ApiError('You do not have permission to perform this action.', status);
      if (status === 404) return new ApiError('The requested resource was not found.', status);
      if (status === 405) return new ApiError('Method not allowed. The server rejected this type of request.', status);
      if (status === 409) return new ApiError('A conflict occurred. Please refresh and try again.', status);
      if (status && status >= 500) return new ApiError('Server error. Please try again later.', status);
    }

    if (err && typeof err === 'object' && 'code' in err && (err as { code: string }).code === 'ERR_NETWORK') {
      return new ApiError('Network error. Please check your connection and try again.');
    }

    return new ApiError('An unexpected error occurred.');
  }
}
